import React, { Component } from 'react';
import { Label } from 'reactstrap';
import Select from 'react-select';
import { sortBy } from 'lodash'
import { service } from '../main/Service';
import 'react-select/dist/react-select.css';
import './processFile.css';

class Clientdropdown extends Component {

    state = {
        data: [],
        selected: undefined
    }

    constructor(props) {
        super(props);
        this.getToken = this.getToken.bind(this);
        this.onChange = this.onChange.bind(this);
        this.uploadCSV = this.props.uploadCSV.bind(this);
        this.loadingAnim = this.props.loading.bind(this);
        this.noGraph = this.props.noGraph.bind(this);
        this.noMap = this.props.noMap.bind(this);
        this.noClient = this.props.noClient.bind(this);
        this.uploadIcon = this.props.uploadIcon.bind(this);
        this.setData = this.props.setData.bind(this);
        this.tableGraph = this.props.tableGraph.bind(this);
    }

    onChange(e) {
        this.loadingAnim(false);
        this.noMap(false);
        this.noGraph(false);
        this.uploadCSV(false);
        this.noClient(false);
        this.uploadIcon(false);
        this.setData(false, {});
        this.tableGraph(false,{});
        this.loadingAnim(true);
        if(!e) {
            this.setState({
                selected: null
            });
            this.loadingAnim(false);
            this.noClient(true);
            return;
        }
        service.getMap(e.crg_energyprogramid).then(data =>{
            const id = e.crg_energyprogramid;
            const client = this.state.data.find(x => x.crg_energyprogramid === id);
            this.setState({ selected: client.crg_energyprogramid });
            this.loadingAnim(false);
            if(data.predictEnabled){
                this.uploadCSV(true);
                this.uploadIcon(true);
            }
            else{
                this.noMap(true);
            }
        });        
    }

    componentDidMount() {
        service.getClientName().then(data => {
            this.setState({ data: sortBy(data, ['clientName'])});
            this.loadingAnim(false);
            this.noClient(true);
        })
    }

    getToken() {
        return localStorage.getItem('id_token');
    }

    render() {
        return (
            <div>
                <Label for="exampleDate" onClick={this.props.action}>Client Selection</Label>
                <Select
                    name="client-dropdown"
                    placeholder="Select an Energy Program"
                    className="clientSelector"
                    clearable={true}
                    value={this.state.selected}
                    onChange={this.onChange}
                    options={this.state.data.map(item => {
                        item.value = item.crg_energyprogramid;
                        item.label  = item.clientName;
                        return item;
                    })}
                />
            </div>
        );
    }

}

export default Clientdropdown;
